import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { DefaultErrorMessage } from '../displayStrings';
import usersApi from '../api/users.api';

export const useUsers = () => {
  const { showToast } = useToastProvider();
  const { companyId } = useCurrentUser();

  return useQuery(['usersList', companyId], () => usersApi.getAllUsers(companyId, { status: 'accepted' }), {
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000,
    onError: () => {
      showToast({
        title: 'Could not retrieve users',
        description: DefaultErrorMessage,
        status: 'error',
      });
    },
  });
};
